import { useEffect } from 'react'

import { getDirection } from '@/content/i18n'
import type { Locale } from '@/types/site'

export function useDirection(locale: Locale) {
  const direction = getDirection(locale)

  useEffect(() => {
    document.documentElement.lang = locale
    document.documentElement.dir = direction
  }, [direction, locale])

  return direction
}
